import React from 'react';
import { FaStar } from 'react-icons/fa'; // Importa le stelle per la valutazione

function GenIBotsPage() {
  return (
    <div className="min-h-screen font-sans text-white bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900">
      {/* Banner introduttivo */}
      <section id="intro" className="py-24 px-6 bg-slate-900 text-center">
        <div className="max-w-3xl mx-auto bg-white/5 backdrop-blur-sm rounded-3xl shadow-2xl p-10 border-4 border-[conic-gradient(at_top_left,_var(--tw-gradient-stops))] border-transparent bg-gradient-to-tr from-indigo-600 via-purple-500 to-pink-500">
          <h2 className="text-4xl font-bold text-white mb-6 drop-shadow">GEN I BOT</h2>
          <p className="text-indigo-200 text-sm mb-6 max-w-xl mx-auto">
            La generazione 1 dei nostri bot, progettata per una performance sicura e affidabile nel mercato.
          </p>
          <div className="flex justify-center items-center gap-4 mb-4">
            <span className="text-yellow-300 font-bold text-lg">🏆 Capitale a partire da €200</span>
            <div className="flex gap-1 text-yellow-400">
              {[...Array(5)].map((_, i) => <FaStar key={i} />)}
            </div>
          </div>
          <p className="text-indigo-200 text-sm mb-6 max-w-xl mx-auto">
            Scopri come i nostri bot della generazione 1 possono aiutarti ad ottenere il massimo dai tuoi investimenti, con una tecnologia avanzata e una sicurezza impeccabile.
          </p>
          <p className="text-3xl font-bold text-white mb-4">
            <span className="line-through text-gray-400 mr-3">€499</span>
            €199 <span className="text-sm font-normal">una tantum</span>
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4">
            <button className="bg-yellow-400 hover:bg-yellow-300 text-black font-semibold text-lg px-6 py-3 rounded-full shadow-lg transition-transform hover:scale-105">
              Lock in your price
            </button>
            <button className="bg-slate-800 hover:bg-slate-700 text-white font-medium text-md px-6 py-3 rounded-full shadow-md">
              Richiedi info
            </button>
          </div>
        </div>
      </section>

      {/* Sezione di pagamento */}
      <section id="payment" className="py-24 px-6 bg-slate-800 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-6">Acquista il Gen I Bot</h2>
          <p className="text-indigo-200 text-sm mb-6 max-w-xl mx-auto">
            Completa il pagamento per ricevere accesso immediato al Gen I Bot e inizia a fare trading in modo sicuro ed efficiente.
          </p>
          {/* Qui puoi inserire il modulo di pagamento o il link che reindirizza al sistema di pagamento */}
          <div className="flex justify-center gap-4">
            <button className="bg-yellow-400 hover:bg-yellow-300 text-black font-semibold text-lg px-6 py-3 rounded-full shadow-lg">
              Acquista ora
            </button>
            <button className="bg-slate-800 hover:bg-slate-700 text-white font-medium text-md px-6 py-3 rounded-full shadow-md">
              Contattaci
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GenIBotsPage;
